import axios, { CancelToken } from 'axios';
import { setStorageSSOToken } from '../helpers/Auth';
import Auth from '../services/Auth';

const bffMultiRequest = requests => {
  const timeout = 30000;
  const apiToken =
    typeof window !== 'undefined' && window.localStorage.getItem('tkn_sso');
  const source = CancelToken.source();
  const r = requests.map(async req => {
    const axiosConfig = {
      baseURL: `${process.env.BFF_MULTI_CHANNEL}${req.url}`,
      method: req.method,
      cancelToken: source.token,
    };
    if (req.data) {
      axiosConfig.data = req.data;
    }

    const validToken = Auth.validExpiredSSOToken();
    if (!validToken) {
      const response = await Auth.updateTokenSSO();
      setStorageSSOToken(response?.data?.access_token);
      axiosConfig.headers = {
        Authorization: `Bearer ${response?.data?.access_token}`,
      };

      return axios(axiosConfig);
    }
    axiosConfig.headers = {
      Authorization: `Bearer ${apiToken}`,
    };
    return axios(axiosConfig);
  });
  const onSuccess = axios.spread((...responses) => {
    return responses.map(resp => resp.data);
  });
  const onError = error => {
    return Promise.reject(error.response || error);
  };
  const onEnd = response => {
    return response;
  };
  setTimeout(() => {
    source.cancel();
  }, timeout);
  return axios
    .all(r)
    .then(onSuccess)
    .catch(onError)
    .then(onEnd);
};
export default bffMultiRequest;
